import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordForm } from '../components/auth/ForgotPasswordForm';
import { AuthLayout } from '../components/layouts/AuthLayout';

export const Route = createFileRoute('/forgot-password')({
    component: () => (
        <AuthLayout>
            <ForgotPasswordForm />
        </AuthLayout>
    ),
});
